<template>
  <a-drawer width="55vw" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="level">
        <span slot="label">
          <a-tooltip>
            {{ $t('等级名称') }}<template slot="title">{{ $t('等级名称') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.level" :maxLength="100" :placeholder="$t('通用.输入.请输入') + $t('等级名称')" />
      </a-form-model-item>
      <a-form-model-item prop="commissionRatio">
        <span slot="label">
          <a-tooltip>
            {{ $t('带货佣金（%）') }}<template slot="title">{{ $t('带货佣金') }}</template>
          </a-tooltip>
        </span>
        <a-input-number
          :min="0"
          :max="100"
          style="width: 100%"
          v-model="form.commissionRatio"
          :placeholder="$t('通用.输入.请输入') + $t('带货佣金')"
        />
      </a-form-model-item>
      <a-form-model-item prop="giftRatio">
        <span slot="label">
          <a-tooltip>
            {{ $t('礼物抽成（%）') }}<template slot="title">{{ $t('礼物抽成') }}</template>
          </a-tooltip>
        </span>
        <a-input-number
          :min="0"
          :max="100"
          style="width: 100%"
          v-model="form.giftRatio"
          :placeholder="$t('通用.输入.请输入') + $t('礼物抽成')"
        />
      </a-form-model-item>

      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video
          style="width: 100%"
          :src="previewUrl"
          ref="myVideo"
          :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'"
          :controls="true"
        ></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('通用.按钮.保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('通用.按钮.取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getAnchorsLevel, addAnchorsLevel, updateAnchorsLevel } from '@/api/trade/anchorsLevel'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject } from '@/api/tool/oss'

export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag,
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        level: null,

        commissionRatio: null,
        giftRatio: null,

        status: 0,

        createTime: null,

        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        level: [{ required: true, message: this.$t('等级名称不能为空'), trigger: 'blur' }],
        commissionRatio: [{ required: true, message: this.$t('带货佣金比例不能为空'), trigger: 'blur' }],
        giftRatio: [{ required: true, message: this.$t('礼物抽成比例不能为空'), trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {},
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  mounted() {},
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    previewVideoCancel() {
      this.previewVideoVisible = false
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        level: null,
        commissionRatio: null,
        status: 0,
        createTime: null,
        giftRatio: null,
        remark: null,
      }
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getAnchorsLevel({ id: id }).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateAnchorsLevel(this.form)
              .then((response) => {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            message = this.$t('通用.文本.修改成功')
            addAnchorsLevel(this.form)
              .then((response) => {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
